import { __decorate, __metadata } from "tslib";
import _ from 'lodash';
import { injectable } from 'inversify';
let HttpServiceHelper = class HttpServiceHelper {
    constructor(errorHandlerService) {
        // #region 通用处理相关
        this._errorDisplayProxy = _.noop;
        this._errorDisplayProxy = errorHandlerService.errorDisplay;
    }
    // 用于后期显示设置， 有的错误必须依靠vue root
    setErrorDisplay(fn) {
        this._errorDisplayProxy = fn;
    }
    // #endregion
    request(config) {
        throw new Error('Must Implement');
    }
    get(config) {
        config = _.merge({
            method: 'get',
        }, config);
        return this.request(config);
    }
    post(config) {
        config = _.merge({
            method: 'post',
        }, config);
        return this.request(config);
    }
    postForm(config) {
        config = _.merge({
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
        }, config);
        return this.request(config);
    }
    putForm(config) {
        config = _.merge({
            method: 'put',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
        }, config);
        return this.request(config);
    }
    postMultipartForm(config) {
        config = _.merge({
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }, config);
        return this.request(config);
    }
    put(config) {
        config = _.merge({
            method: 'put',
        }, config);
        return this.request(config);
    }
    patch(config) {
        config = _.merge({
            method: 'patch',
        }, config);
        return this.request(config);
    }
    patchForm(config) {
        config = _.merge({
            method: 'patch',
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }, config);
        return this.request(config);
    }
    delete(config) {
        config = _.merge({
            method: 'delete',
        }, config);
        return this.request(config);
    }
};
HttpServiceHelper = __decorate([
    injectable(),
    __metadata("design:paramtypes", [Object])
], HttpServiceHelper);
export { HttpServiceHelper };
